export default __webpack_public_path__ + "static/media/912.6c4a5e4f.png";